import { ChangeDetectionStrategy, Component } from '@angular/core'

import { BaseIconComponent } from '../base-icon.component'

@Component({
  selector: 'app-icon-ai-chat-outline',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_29930_12176)">
        <path
          d="M21.4478 20.2803H20.647C20.1999 20.2801 19.8376 19.9188 19.8374 19.4717V13.7959C19.8374 13.3486 20.1997 12.9865 20.647 12.9863H21.4478V12.1865C21.4478 7.74515 17.8461 4.14362 13.4048 4.14355C11.2717 4.14355 9.22574 4.99057 7.71729 6.49902C6.2089 8.00747 5.36182 10.0535 5.36182 12.1865V12.9863H6.16162C6.60904 12.9863 6.97119 13.3485 6.97119 13.7959V19.4717C6.97095 19.9189 6.60889 20.2803 6.16162 20.2803H4.55225C3.91056 20.2802 3.29552 20.0261 2.84229 19.5723V19.5713L2.68115 19.3945C2.32827 18.9644 2.1333 18.4229 2.1333 17.8613V15.4053C2.1333 14.7635 2.38839 14.1486 2.84229 13.6953V13.6943C3.29552 13.2405 3.91056 12.9864 4.55225 12.9863H5.35205V12.1865C5.35205 10.0513 6.20125 8.00237 7.71143 6.49219C9.22157 4.98224 11.2697 4.13379 13.4048 4.13379C17.8517 4.13385 21.4565 7.73957 21.4565 12.1865V12.9863H22.2573C22.8988 12.9865 23.5132 13.2407 23.9663 13.6943L23.9673 13.6953C24.4212 14.1486 24.6763 14.7635 24.6763 15.4053V17.8613C24.6763 18.5031 24.4211 19.118 23.9673 19.5713L23.9663 19.5723C23.5131 20.026 22.8989 20.2802 22.2573 20.2803H21.4565V22.6904C21.4564 23.582 20.7338 24.3047 19.8423 24.3047H16.6284V25.1045C16.6284 25.5519 16.2662 25.9141 15.8188 25.9141H14.0396C13.5924 25.9138 13.231 25.5517 13.231 25.1045V23.4951C13.231 23.0478 13.5923 22.6858 14.0396 22.6855H15.8188C16.2663 22.6855 16.6284 23.0477 16.6284 23.4951V24.2949H19.8423C20.7283 24.2949 21.4476 23.5764 21.4478 22.6904V20.2803Z"
          [attr.stroke]="color"
          style="stroke-opacity:1;"
          stroke-width="1.6"
        />
        <path
          d="M23.9631 0L24.6637 3.26251L27.9262 3.96309L24.6637 4.66367L23.9631 7.92618L23.2625 4.66367L20 3.96309L23.2625 3.26251L23.9631 0Z"
          [attr.fill]="color"
          style="fill-opacity:1;"
        />
      </g>
      <defs>
        <clipPath id="clip0_29930_12176">
          <rect width="28" height="28" [attr.fill]="color" style="fill-opacity:1;" />
        </clipPath>
      </defs>
    </svg>
  `,
  styles: [
    `
      :host {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AiChatOutlineIconComponent extends BaseIconComponent {}
